import { overlay } from 'overlay-kit';

import { SaveToBoardsDialog } from '../save-to-boards-dialog';

type RequestSaveToBoardsDialogParams = {
  postIds: string[];
  onSaved?: () => void | Promise<void>;
};

export function requestSaveToBoardsDialog({
  postIds,
  onSaved,
}: RequestSaveToBoardsDialogParams): Promise<'saved' | 'cancel'> {
  return new Promise((resolve) => {
    let isSettled = false;

    overlay.open(({ isOpen, close }) => {
      if (!isOpen) return null;

      const handleComplete = (action: 'saved' | 'cancel') => {
        if (isSettled) return;
        isSettled = true;
        resolve(action);
        close();
      };

      return (
        <SaveToBoardsDialog
          isOpen={isOpen}
          close={() => handleComplete('cancel')}
          postIds={postIds}
          onSaved={async () => {
            await onSaved?.();
            handleComplete('saved');
          }}
        />
      );
    });
  });
}
